import { fmtCVE } from "@/lib/format";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Plus, Trash } from "@phosphor-icons/react";

const uid = () => Math.random().toString(36).slice(2, 10);

export function WorkHours({ entries, members, onChange }) {
  const list = entries || [];
  const upd = (i, patch) => { const a = [...list]; a[i] = { ...a[i], ...patch }; onChange(a); };
  const totalHours = list.reduce((s, e) => s + (Number(e.hours) || 0), 0);
  const totalCost = list.reduce((s, e) => s + (Number(e.hours) || 0) * (Number(e.rate) || 0), 0);
  const byWorker = list.reduce((m, e) => { const k = e.worker_name || "—"; m[k] = (m[k] || 0) + (Number(e.hours) || 0); return m; }, {});

  return (
    <div className="space-y-3" data-testid="work-hours">
      <datalist id="work-members">{members.map((m) => <option key={m.id} value={m.name} />)}</datalist>
      <div className="hidden grid-cols-12 gap-2 text-[11px] font-medium uppercase tracking-wide text-muted-foreground sm:grid">
        <span className="col-span-3">Data</span><span className="col-span-3">Trabalhador</span><span className="col-span-2">Horas</span>
        <span className="col-span-2">CVE/hora</span><span className="col-span-1 text-right">Custo</span>
      </div>
      {list.map((e, i) => (
        <div key={e.id || i} className="grid grid-cols-12 items-center gap-2 border-b border-border/60 pb-2" data-testid={`hours-row-${i}`}>
          <Input className="col-span-6 h-8 sm:col-span-3" type="date" value={e.date || ""} onChange={(ev) => upd(i, { date: ev.target.value })} />
          <Input className="col-span-6 h-8 sm:col-span-3" list="work-members" placeholder="Nome" value={e.worker_name}
            onChange={(ev) => upd(i, { worker_name: ev.target.value, worker_id: members.find((m) => m.name === ev.target.value)?.id || null })}
            data-testid={`hours-worker-${i}`} />
          <Input className="col-span-4 h-8 sm:col-span-2" type="number" step="0.5" min="0" placeholder="Horas" value={e.hours}
            onChange={(ev) => upd(i, { hours: ev.target.value })} data-testid={`hours-hours-${i}`} />
          <Input className="col-span-4 h-8 sm:col-span-2" type="number" min="0" placeholder="CVE/hora" value={e.rate}
            onChange={(ev) => upd(i, { rate: ev.target.value })} data-testid={`hours-rate-${i}`} />
          <span className="col-span-3 text-right text-sm sm:col-span-1">{fmtCVE((Number(e.hours) || 0) * (Number(e.rate) || 0))}</span>
          <Button variant="ghost" size="icon" className="col-span-1 h-8 w-8 text-destructive" onClick={() => onChange(list.filter((_, j) => j !== i))}><Trash size={15} /></Button>
        </div>
      ))}
      <div className="flex flex-wrap items-center justify-between gap-3">
        <Button variant="outline" size="sm" className="rounded-full" data-testid="add-hours-btn"
          onClick={() => onChange([...list, { id: uid(), date: new Date().toISOString().slice(0, 10), worker_name: "", hours: 8, rate: 0, notes: "" }])}>
          <Plus size={15} className="mr-1" /> Registar horas
        </Button>
        <span className="text-sm font-semibold" data-testid="hours-total">{totalHours} h · {fmtCVE(totalCost)}</span>
      </div>
      {Object.keys(byWorker).length > 0 && (
        <div className="flex flex-wrap gap-2 pt-1">
          {Object.entries(byWorker).map(([k, v]) => (
            <span key={k} className="rounded-full bg-secondary px-3 py-1 text-xs">{k}: <b>{v} h</b></span>
          ))}
        </div>
      )}
    </div>
  );
}
